import useDevice from "hooks/useDevice"
import Image from "next/image"
import React, { FunctionComponent, ReactNode } from "react"

type Props = {
  currentFormStep: number
}

const getText = (currentFormStep: number): ReactNode | string => {
  switch (currentFormStep) {
    case 1: {
      return (
        <span>
          Leap’s courses are tailored for IELTS <br /> Academic and General exam
          types
        </span>
      )
    }
    case 2: {
      return (
        <span>
          Leap provides courses suitable for
          <br />
          students and working professionals!
        </span>
      )
    }
    case 3: {
      return (
        <span>
          The best time to start <br className="hidden md:block" /> preparing{" "}
          <br className="md:hidden" />
          for IELTS is today!
        </span>
      )
    }
    case 4: {
      return (
        <span>
          <span className="text-[#F2A156] font-bold">90%</span> of Leap’s
          Students <br className="hidden md:block" /> score{" "}
          <br className="md:hidden" /> 7.5+ Band in IELTS.
        </span>
      )
    }
    case 5: {
      return (
        <p className="text-sm md:text-2xl text-[#E8E8E8]">
          Your dream life abroad starts <br /> with a
          <span className="text-[#F2A156]"> good IELTS score</span>
        </p>
      )
    }
  }
}
const StudentContextText: FunctionComponent<Props> = ({ currentFormStep }) => {
  const { isMobile } = useDevice()
  return (
    <div className="flex items-center rounded-lg relative h-[70px] md:h-[111px]">
      <p className="text-white md:text-[20px] px-4 md:px-0 md:pl-6 text-[14px] z-10">
        {getText(currentFormStep)}
      </p>
      {isMobile ? (
        <Image
          src= {`${process.env.CDN_URL}/assets/images/ielts/banner/mweblaptop.png`}
          alt="laptop"
          layout="fill"
          objectFit="cover"
          className="rounded-lg"
        />
      ) : (
        <Image
          src= {`${process.env.CDN_URL}/assets/images/ielts/banner/laptop.jpg`}
          alt="laptop"
          layout="fill"
          objectFit="cover"
          className="rounded-lg"
        />
      )}
    </div>
  )
}
export default StudentContextText
